module.exports = __webpack_public_path__ + "img/icon-test-info.1e4e2278.svg";